var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('BreadCrumb', {
    attrs: {
      "parentRouteName": "BookingSelectList",
      "extra-items": [{
        text: _vm.bookingPresetName,
        to: 'BookingList',
        params: _vm.$route.params.id
      }, '通知設定']
    }
  })], 1)]), _c('div', {
    staticClass: "email-wrapper wrapper"
  }, [_c('div', {
    staticClass: "row bg-white"
  }, [_c('div', {
    staticClass: "col-md-2 mail-sidebar pt-3"
  }, [_c('div', {
    staticClass: "menu-bar"
  }, [_c('ul', {
    staticClass: "menu-items"
  }, [_c('li', {
    class: {
      active: true,
      'has-checkbox': true,
      'has-checkbox--checked': _vm.bookingPresetId
    }
  }, [_c('a', [_vm._v("通知設定")])])])])]), _c('div', {
    staticClass: "col-md-10 main-view"
  }, [_c('b-overlay', {
    attrs: {
      "show": _vm.showLoading
    }
  }, [_c('b-card', [_c('div', {
    staticClass: "row d-flex mb-4 mb-xl-2"
  }, [_c('h4', {
    staticClass: "col-12 col-xl-6 mb-3 font-weight-bold"
  }, [_vm._v(" " + _vm._s(_vm.bookingPresetName) + " ")]), _c('div', {
    staticClass: "col-12 col-xl-6 mb-3"
  }, [_c('AppSingleSelect', {
    attrs: {
      "options": _vm.branchOptions
    },
    on: {
      "input": _vm.handleBranchChange
    },
    model: {
      value: _vm.branch,
      callback: function callback($$v) {
        _vm.branch = $$v;
      },
      expression: "branch"
    }
  })], 1)]), _c('b-form-group', [_c('b-form-checkbox', {
    model: {
      value: _vm.notification.dashboard.enabled,
      callback: function callback($$v) {
        _vm.$set(_vm.notification.dashboard, "enabled", $$v);
      },
      expression: "notification.dashboard.enabled"
    }
  }, [_vm._v(" 啟用主控台分店預約通知 ")])], 1), _c('b-form-group', {
    staticClass: "mb-4"
  }, [_c('b-form-radio-group', {
    attrs: {
      "disabled": !_vm.notification.dashboard.enabled
    },
    on: {
      "input": _vm.handleStaffModeChange
    },
    model: {
      value: _vm.staffMode,
      callback: function callback($$v) {
        _vm.staffMode = $$v;
      },
      expression: "staffMode"
    }
  }, [_c('b-form-radio', {
    attrs: {
      "value": "all"
    }
  }, [_vm._v("全部預約")]), _c('b-form-radio', {
    attrs: {
      "value": "specific"
    }
  }, [_vm._v("特定員工預約")])], 1)], 1), _c('b-table', {
    attrs: {
      "striped": "",
      "hover": "",
      "responsive": "",
      "items": _vm.staffs,
      "fields": _vm.staffFields
    },
    scopedSlots: _vm._u([{
      key: "cell(selected)",
      fn: function fn(data) {
        return [_c('b-form-checkbox', {
          attrs: {
            "checked": _vm.selectedStaffIds.includes(data.item.id),
            "disabled": !_vm.isStaffCheckboxEnabled
          },
          on: {
            "change": function change(checked) {
              return _vm.toggleStaff(data.item.id, checked);
            }
          }
        })];
      }
    }, {
      key: "cell(avatar)",
      fn: function fn(data) {
        return [_c('div', {
          staticClass: "d-flex align-items-center justify-content-center"
        }, [data.item.avatar_url ? _c('img', {
          staticClass: "thumb-image",
          attrs: {
            "src": data.item.avatar_url,
            "alt": ""
          }
        }) : _c('b-avatar', {
          attrs: {
            "variant": "secondary",
            "size": "2rem"
          }
        })], 1)];
      }
    }])
  }, [_c('template', {
    slot: "head(selected)"
  }, [_vm.isStaffCheckboxEnabled ? _c('b-form-checkbox', {
    attrs: {
      "checked": _vm.isAllStaffSelected,
      "indeterminate": _vm.isStaffIndeterminate
    },
    on: {
      "change": _vm.toggleAllStaff
    }
  }) : _vm._e()], 1)], 2), _c('div', {
    staticClass: "d-flex justify-content-center mt-4"
  }, [_c('b-button', {
    staticClass: "mr-3",
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(" 返回 ")]), _c('b-button', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(" 儲存 ")])], 1)], 1)], 1)], 1)])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }